import React, {FC, ReactNode, createContext} from 'react';
import {Device} from '../Types/types';
import {useCustomSWR} from '../hooks/customSWR';

interface DevicesContextType {
	devices: Device[];
	devicesAreLoading: boolean;
	devicesError: undefined | Error;
	refreshDevices: () => void;
}

export const DevicesContext = createContext<DevicesContextType | undefined>(undefined);

interface DevicesContextProviderProps {
	children: ReactNode;
}

export const DevicesContextProvider: FC<DevicesContextProviderProps> = ({children}) => {
	const {data: devices, isError: devicesError, isLoading, mutate: refreshDevices} = useCustomSWR<Device[]>(`${process.env.REACT_APP_API_URL}getDevices`);

	if (devicesError) {
		console.error(devicesError);
	}

	return <DevicesContext.Provider value={{devices: devices || [], devicesAreLoading: isLoading, devicesError, refreshDevices}}>{children}</DevicesContext.Provider>;
};
